import React from 'react';
import PropTypes from 'prop-types';
import { Alert } from '@mui/material';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const NoClabeAlert = ({ show }) => {
  const { t } = useTranslation();

  if (!show) {
    return null;
  }

  return (
    <Alert severity="warning" sx={{ mb: 2 }}>
      {t('CONTRACT_VIEW.CONTRACT_DETAIL.TRANSFER_NO_CLABE_MESSAGE')}
      {' '}
      <Link
        to="/santander-clabes"
        target="_blank"
        rel="noopener noreferrer"
      >
        {t('SANTANDER_CLABES.ASSIGN_CLABE')}
      </Link>
    </Alert>
  );
};

NoClabeAlert.propTypes = {
  show: PropTypes.bool.isRequired
};

export default NoClabeAlert;

